import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';

export function composeVerticalGapSizeClasses(vGap: Adaptive<number>): string {
    if (typeof vGap === 'object') {
        return clsx(
            vGap.base && `gap-y-${vGap.base}`,
            vGap.sm && `sm:gap-y-${vGap.sm}`,
            vGap.md && `md:gap-y-${vGap.md}`,
            vGap.lg && `lg:gap-y-${vGap.lg}`,
            vGap.xl && `xl:gap-y-${vGap.xl}`,
            vGap['2xl'] && `2xl:gap-y-${vGap['2xl']}`
        );
    }

    return `gap-y-${vGap}`;
}
